"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Theme = _interopRequireDefault(require("../../assets/Theme4.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ImageMenuContent = _interopRequireDefault(require("./ImageMenuContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Theme["default"]);

var Menu = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Menu, _React$PureComponent);

  function Menu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      renderContent: true,
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "animation", function () {
      clearTimeout(_this.timeout);

      _this.setState({
        isOpen: false
      });

      _this.timeout = setTimeout(function () {
        _this.setState({
          isOpen: true
        });
      }, 100);
    });

    return _this;
  }

  var _proto = Menu.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.animation();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var data = this.props.data;
    var prevData = prevProps.data;

    if (data.length !== prevData.length) {// this.animation();
    } else {
      if (data.length > 0 && data[0].id != prevData[0].id) {// this.animation();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        selected = _this$props.selected,
        data = _this$props.data,
        onClick = _this$props.onClick,
        scrollToSelected = _this$props.scrollToSelected,
        animation = _this$props.animation,
        isShow = _this$props.isShow,
        THUMB_DOMAIN = _this$props.THUMB_DOMAIN,
        urlSplicing = _this$props.urlSplicing,
        seenScenes = _this$props.seenScenes,
        payScenes = _this$props.payScenes,
        disableTip = _this$props.disableTip,
        ui = _this$props.ui,
        selectedChangeResize = _this$props.selectedChangeResize;
    var isOpen = this.state.isOpen;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("ImageMenuTheme4", {
        isOpen: isShow ? animation ? isOpen : true : false
      })
    }, /*#__PURE__*/_react["default"].createElement(_ImageMenuContent["default"], {
      selectedChangeResize: selectedChangeResize,
      disableTip: disableTip,
      THUMB_DOMAIN: THUMB_DOMAIN,
      urlSplicing: urlSplicing,
      scrollToSelected: scrollToSelected,
      data: data,
      selected: selected,
      onClick: onClick,
      seenScenes: seenScenes,
      payScenes: payScenes,
      ui: ui
    }));
  };

  return Menu;
}(_react["default"].PureComponent);

var _default = Menu;
exports["default"] = _default;
module.exports = exports.default;